import { Box, Button, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CircularProgress } from "@mui/material";


import { useState, useRef, useEffect } from "react";
import dayjs from "dayjs";

import { djangoApi } from "../../utils/axios/axios.utils";
import SorteiosList from "../../components/sorteios";
import SkeletonTable from "./skeleton-table";

import { IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

import { Checkbox, FormControlLabel } from "@mui/material";
import toast from "react-hot-toast";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";



const SorteiosPage = () => {
    const [selectedDate, setSelectedDate] = useState(dayjs()); // Default to current month & year
    const [gambleDate, setGambleDate] = useState([]);
    const tableRef = useRef(null);

    const [monthName, setMonthName] = useState(null);
    const [printData, setPrintData] = useState([]);
    const [checked, setChecked] = useState({});
    const [firstRender, setFirstRender] = useState(true);

    console.log('checed: ', checked)

    useEffect(() => {
        const date = new Date(selectedDate);
        const monthInPortuguese = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(date);
        setMonthName(monthInPortuguese.charAt(0).toUpperCase() + monthInPortuguese.slice(1))
    }, [selectedDate]);

    const handleChange = (newValue) => {
        setSelectedDate(newValue);
    };

    useEffect(() => {
        if (gambleDate.length > 0) {
            const maxValuePerEntry = 250;
            const newArr = gambleDate
                .filter((kit) => kit.total_value_sold > 0)
                .filter((kit) => checked[kit.id])
                .flatMap((data) => {
                    const totalEntries = Math.floor(data.total_value_sold / maxValuePerEntry); // Number of records needed
                    return Array.from({ length: totalEntries }, (_, index) => ({
                        name: data.seller.nome,
                        value: data.total_value_sold,
                        coupon: `${String(index + 1).padStart(2, "0")}/${String(totalEntries).padStart(2, "0")}`,
                    }));
                });
            setPrintData(newArr)
        }
    }, [gambleDate, checked]);

    const [loading, setLoading] = useState(false);
    const [selectAll, setSelectAll] = useState(true);

    const fetchData = async () => {
        setGambleDate([])
        setPrintData([])
        setLoading(true); // Start loading
        setFirstRender(true)
        try {
            await djangoApi
                .post("products/kits_active/get_all_kits_by_pay_date/", { data: selectedDate }, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log('resposeta', res.data)
                    const { data } = res.data;
                    setLoading(false)
                    console.log('dados: ', data)
                    setGambleDate(data)
                });
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false); // Stop loading
        }
    };



    function truncateText(text, maxLength) {
        if (text.length > maxLength) {
            return text.substring(0, maxLength - 3) + "..."; // Cut and add "..."
        }
        return text;
    }

    const handlePrint = async () => {
        if (!tableRef.current) return;

        try {
            // Fix white screen by forcing visibility
            // tableRef.current.style.display = "grid";

            // Capture table as image
            // const canvas = await html2canvas(tableRef.current, {
            //     backgroundColor: "#fff",
            //     scale: 2, // Improves quality
            //     useCORS: true, // Allow cross-origin images
            //     logging: true, // Debugging purpose
            // });

            // const imgData = canvas.toDataURL("image/png");

            // // Create PDF
            // const pdf = new jsPDF("p", "mm", "a4");
            // const imgWidth = 210; // A4 width in mm
            // const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // // Ensure content fits in A4
            // pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight > 297 ? 297 : imgHeight);
            // pdf.save("table.pdf");
            // tableRef.current.style.display = "none";

            const pdf = new jsPDF("p", "mm", "a4");
            pdf.setFont("Cabin"); // Use Cabin font if added
            // const pageWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const columns = 4; // **Fixed to 4 columns per row**
            const margin = 5;
            const cardWidth = 45; // Increase a bit to reflect the larger width
            const cardHeight = 45; // Adjust height for better spacing
            let x = margin;
            let y = margin + 10;


            printData.forEach((item, index) => {
                // Draw a rectangle (card border) with rounded corners
                pdf.roundedRect(x, y, cardWidth, cardHeight, 4, 4); // 8px border radius (4mm each side)

                // Centered text
                pdf.setFontSize(10);
                pdf.setFont("Cabin", 'bold'); // Use Cabin font if added
                pdf.text(`Sorteio - ${monthName} - Pitaya`, x + cardWidth / 2, y + 10, { align: "center" });
                pdf.setFont("Cabin", 'normal'); // Use Cabin font if added
                pdf.setFontSize(8); // Set font size for item name
                pdf.text(`${truncateText(item.name, 20)}`, x + cardWidth / 2, y + 18, { align: "center" });
                pdf.setFontSize(9); // Set font size for item name
                pdf.text(`R$ ${formatNumber(Number(item.value))}`, x + cardWidth / 2, y + 26, { align: "center" });
                pdf.text(`Cupom: ${item.coupon}`, x + cardWidth / 2, y + 34, { align: "center" });

                // Move to next column
                x += cardWidth + margin;

                // If we reach 4 columns, reset to next row
                if ((index + 1) % columns === 0) {
                    x = margin; // Reset X
                    y += cardHeight + margin; // Move down

                    // If we exceed the page height, add a new page
                    if (y + cardHeight > pageHeight - margin) {
                        pdf.addPage();
                        y = margin + 10; // Reset Y
                    }
                }
            });

            pdf.save(`sorteio-${monthName}.pdf`);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
        toast.success(
            `Cards para o Sorteio gerados com Sucesso!!`,
            {
                position: 'bottom-right'
            }
        );
    }

    const handleSelectAll = () => {
        setSelectAll(!selectAll)
    }

    const formatNumber = number => {
        return number?.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }

    return (
        <Box mt={5} p={5}>
            {/* <Typography variant="h3">Selecione um período para o filtro</Typography> */}
            <Box mt={2} sx={{
                display: 'flex',
                gap: '20px',
                maxHeight: '35px',
                justifyContent: 'space-between',
                minWidth: '1200px'
            }}>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '20px'
                    }}
                >

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            size="small"
                            label={'Mês e Ano'}
                            views={['month', 'year']}
                            value={selectedDate} // Set default value
                            onChange={handleChange} // Handle change
                        />
                    </LocalizationProvider>
                    <Button
                        size="small"
                        variant="contained"
                        color="success"
                        onClick={fetchData}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {loading ? "Carregando" : "Filtrar"}
                    </Button>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        gap: '20px'
                    }}
                >

                    {
                        gambleDate.length > 0 && (
                            <IconButton color="inherit" onClick={handlePrint} size="large">
                                <PrintIcon sx={{ fontSize: 30 }}/>
                            </IconButton>

                        )
                    }
                </Box>
            </Box>
            {
                loading && (
                    <SkeletonTable />
                )
            }
            {
                gambleDate.length > 0 && (
                    <Box>
                        <FormControlLabel
                            sx={{ marginBottom: '-20px', paddingLeft: '10px' }}
                            control={<Checkbox checked={selectAll}
                                color="secondary" onChange={handleSelectAll}
                            />}
                            label={selectAll ? "Desmarcar Todos" : "Selecionar Todos"}

                        />
                        <SorteiosList 
                        data={gambleDate}
                        selectAll={selectAll} 
                        checked={checked}
                        setChecked={setChecked}
                        firstRender={firstRender}
                        setFirstRender={setFirstRender}
                        />
                    </Box>
                )
            }

            {/* Hidden Table for PDF Export */}
            {/* Table Container */}
            {/* <div ref={tableRef} style={{ padding: "20px", background: "#fff", display: 'none' }}> */}
            <div ref={tableRef}
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(auto-fit, minmax(220px, 1fr))`, // Auto-fits A4 width
                    maxWidth: "210mm", // A4 width limit
                    padding: "20px",
                    gap: "10px",
                    // background: "#fff",
                    marginTop: '20px'
                }}
            >
                {printData.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            display: "grid",
                            gridTemplateRows: "repeat(4, auto)",
                            padding: "15px",
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            background: "#f9f9f9",
                            textAlign: "center",
                            boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                            color: 'black',
                            width: "220px", // Fixed width
                            height: "170px", // Adjust height for better fit
                            gap: "10px",
                        }}
                    >
                        <span style={{ fontWeight: "bold", fontFamily: "'Cabin', sans-serif" }}>Sorteio - {monthName} - Pitaya</span>
                        <span>{item.name}</span>
                        <span>R$ {formatNumber(Number(item.value))}</span>
                        <span>Cupom {item.coupon}</span>
                    </div>
                ))}
            </div>


        </Box>

    );
}

export default SorteiosPage;